module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/chowbus_logo-cbf421d3bb7f8fbd160945b22cec7209.png";